@if (withLink) {
  <a routerLink="/" class="display-flex align-items-center" aria-label="Home">
    <img class="logo logo-light" [src]="path" alt="logo" />
    <img
      class="logo logo-dark"
      [src]="darkPath() || path"
      alt="logo-dark"
      aria-hidden="true"
    />
  </a>
} @else {
  <div class="display-flex align-items-center">
    <img class="logo logo-light" [src]="path" alt="logo" />
    <img
      class="logo logo-dark"
      [src]="darkPath() || path"
      alt="logo-dark"
      aria-hidden="true"
    />
  </div>
}
